import { FormConfigBase } from './abstract/form-config-base.class';
import { CalendarNormalInterface } from '../interfaces/calendar-normal.interface';

export class CalendarNormalModel extends FormConfigBase {
  dateFormat?: string;
  readonlyInput?: boolean;
  required?: boolean;
  requiredText?: string;
  placeholder?: string;
  icon?: string;

  constructor( obj: CalendarNormalInterface ) {
    super( obj );

    this.dateFormat = obj && obj.dateFormat ? obj.dateFormat : 'dd/mm/yyyy';
    this.placeholder = obj && obj.placeholder ? obj.placeholder : '';
    this.icon = obj && obj.icon ? obj.icon : '';
    this.required = obj && obj.required !== undefined ? obj.required : false;
    this.requiredText = obj && obj.requiredText ? obj.requiredText : '';
    this.readonlyInput = obj && obj.readonlyInput !== undefined ? obj.readonlyInput : false;
  }

}
